import script from "./IdUploadStep.vue?vue&type=script&setup=true&lang=js"
export * from "./IdUploadStep.vue?vue&type=script&setup=true&lang=js"

import "./IdUploadStep.vue?vue&type=style&index=0&id=3fdf1c1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdf1c1b"]])

export default __exports__